export default __webpack_public_path__ + "static/media/caspersign_example.26fc292b.pdf";